import type { MegaGridView, MegaGridViewState } from './MegaGridTypes';

export interface MegaGridPersisted {
    /** The live working state, restored on next mount. */
    current: MegaGridViewState | null;
    /** User-saved named views. */
    views: MegaGridView[];
    /** Id of the applied named view, if any. */
    activeViewId: string | null;
}

/** Stable-ish id without relying on Date.now/Math.random in hot paths. */
export function makeViewId(existing: MegaGridView[]): string {
    let n = existing.length + 1;
    const taken = new Set(existing.map((v) => v.id));
    while (taken.has(`view-${n}`)) n += 1;
    return `view-${n}`;
}
